import { Component, inject, OnInit } from '@angular/core';
import { LowerCasePipe, NgStyle } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TippyModule } from '@ngneat/helipopper';

import { isMobileView } from '@core/utils';
import { EventType, SectionType, TaskType, Visibility } from '@core/enums';
import { NumberInputDirective } from '@shared/directives/number-input.directive';
import { EventFormComposition } from '@shared/compositions/event-form.composition';
import { ButtonComponent, DropdownComponent, IconComponent, ImageSelectorComponent } from '@shared/components/ui';
import { SimpleFileSelectorInputComponent } from '@shared/components/ui/simple-file-selector-input/simple-file-selector-input.component';
import { DatePickerInputComponent, FormErrorComponent, TimePickerInputComponent } from '@shared/components';

@Component({
  selector: 'app-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss'],
  imports: [
    IconComponent,
    ReactiveFormsModule,
    ImageSelectorComponent,
    TranslateModule,
    DatePickerInputComponent,
    DropdownComponent,
    NgSelectModule,
    FormErrorComponent,
    TimePickerInputComponent,
    ButtonComponent,
    NgStyle,
    NumberInputDirective,
    TippyModule,
    SimpleFileSelectorInputComponent,
    LowerCasePipe,
  ],
})
export class EventFormComponent extends EventFormComposition implements OnInit {
  groupId: number | null = null;
  protected readonly isMobileView = isMobileView;
  protected readonly EventVisibility = Visibility;
  protected readonly TasksType = TaskType;
  protected readonly EventTaskType = TaskType;
  protected readonly SectionType = SectionType;
  private readonly _route = inject(ActivatedRoute);

  constructor() {
    super();
    const eventId = this._route.snapshot.paramMap.get('id');
    if (eventId) {
      this.eventId = +eventId;
    }
  }

  get isUpdateMode(): boolean {
    return !!(this._currentSelectedEvent && this._currentSelectedEvent.id && this._currentSelectedEvent.imageUrl);
  }

  get shouldLockGroupDropdown(): boolean {
    return !!this.groupId;
  }

  ngOnInit() {
    if (!isMobileView()) {
      if (this._dialogRef?.data?.groupId) {
        this.groupId = Number(this._dialogRef.data.groupId);
      }
    } else {
      if (this._bottomSheetService?.currentSheetData?.groupId) {
        this.groupId = Number(this._bottomSheetService.currentSheetData.groupId);
      }
    }

    if (this.groupId && !this.isUpdateMode) {
      this.form.patchValue({
        type: EventType.GroupEvent,
        visibility: Visibility.Group,
      });
      this.form.get('type')?.disable();
      this.form.get('visibility')?.disable();

      const groupCheckInterval = setInterval(() => {
        if (this.groups && this.groups.length > 0) {
          clearInterval(groupCheckInterval);
          this.form.patchValue({ groupId: this.groupId });
          this.form.get('groupId')?.disable();
        }
      }, 100);
    }
  }
}
